export default {
  name: 'education',
  path: 'education',
  component: () => import('@/views/container/Redirect.vue'),
  meta: {title: '安全教育培训', redirect: true, hideSubMenu: true, icon: 'icon-a-jianqu19'},
  children: [
    {
      name: 'education-analyze',
      path: 'education-analyze',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {title: '综合看板', redirect: true, icon: 'icon-home', menuChildren: true},
      children: [
        {
          name: 'education-analyze-list',
          path: '',
          component: () => import('@/views/education/education-analyze/EducationAnalyze.vue'),
          meta: { title: '综合看板', icon: 'icon-home' },
        },
        {
          name: 'personal-archives-other',
          path: 'personal-archives-other',
          component: () => import('@/views/education/personal-archives/PersonalArchives.vue'),
          meta: { title: '个人档案', icon: 'icon-home' }
        },
        {
          name: 'exam-detail-plan-other',
          path: 'exam-detail-plan-other',
          component: () => import('@/views/education/education-train/exam-record/ExamDetail.vue'),
          meta: {title: '记录详情'},
        },
        {
          name: 'my-train-details-other',
          path: 'my-train-details-other',
          component: () => import('@/views/education/education-train/my-train/MyTrainDetail.vue'),
          meta: {title: '培训详情'},
        },
      ],
    },
    {
      name: 'courseware',
      path: 'courseware',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {title: '课件管理', redirect: true, icon: 'icon-folder-open', menuChildren: true},
      children: [
        {
          name: 'courseware-list',
          path: '',
          component: () => import('@/views/education/courseware/list/List.vue'),
          meta: {title: '课件管理列表'},
        },
        {
          name: 'courseware-detail',
          path: 'detail',
          component: () => import('@/views/education/courseware/detail/Detail.vue'),
          meta: {title: '课件管理详情'},
        },
      ],
    },
    {
      name: 'training',
      path: 'training',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {title: '培训管理', redirect: true, icon: 'icon-a-BAI-peixun1'},
      children: [
        {
          name: 'training-plan',
          path: 'training-plan',
          component: () => import('@/views/education/training/training-plan/TrainingPlan.vue'),
          meta: {title: '培训计划'},
        },
        {
          name: 'training-option',
          path: 'training-option',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {title: '培训方案', redirect: true},
          children: [
            {
              name: 'training-option-index',
              path: '',
              component: () => import('@/views/education/training/training-option/TrainingOption.vue'),
              meta: {haveDetail: true},
            },
            // {
            //   name: 'training-option-form',
            //   path: 'form',
            //   component: () => import('@/views/education/training/training-option/training-option-from/TrainingOptionForm.vue'),
            //   meta: {title: '编辑培训任务'},
            // },
            {
              name: 'training-option-details',
              path: 'training-option-details',
              component: () => import('@/views/education/training/training-option/training-option-details/TrainingOptionDetails.vue'),
              meta: {title: '培训方案详情'},
            },
          ],
        },
        {
          name: 'training-task',
          path: 'training-task',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {title: '培训任务', redirect: true},
          children: [
            {
              name: 'training-task-index',
              path: '',
              component: () => import('@/views/education/training/training-task-new/TrainingTask.vue'),
              meta: {haveDetail: true},
            },
            // {
            //   name: 'training-task-form',
            //   path: 'form',
            //   component: () => import('@/views/education/training/training-task/training-task-from/TrainingTaskForm.vue'),
            //   meta: {title: '编辑培训任务'},
            // },
            {
              name: 'training-task-details',
              path: 'training-task-details',
              component: () => import('@/views/education/training/training-task-new/training-task-details/TrainingTaskDetails.vue'),
              meta: {title: '培训任务详情'},
            },
          ],
        },
      ],
    },
    {
      name: 'examination',
      path: 'examination',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {title: '考试管理', redirect: true, icon: 'icon-a-kaoshi4'},
      children: [
        {
          name: 'exam-task',
          path: 'exam-task',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {title: '考试任务管理', redirect: true},
          children: [
            {
              name: 'exam-task-list',
              path: '',
              component: () => import('@/views/education/examination/exam-task/ExamTask.vue'),
              meta: {title: '考试任务管理'},
            },
            {
              name: 'exam-task-form',
              path: 'form',
              component: () => import('@/views/education/examination/exam-task/ExamTaskForm.vue'),
              meta: {title: '新增考试'},
            },
            {
              name: 'exam-task-detail',
              path: 'detail',
              component: () => import('@/views/education/examination/exam-task/exam-task-detail/ExamTaskDetail.vue'),
              meta: {title: '考试任务详情'},
            },
            {
              name: 'underline-exam',
              path: 'underline-exam',
              component: () => import('@/views/education/examination/exam-task/UnderlineExam.vue'),
              meta: {title: '新增考试'},
            },
          ],
        },
        {
          name: 'test-paper',
          path: 'test-paper',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {title: '试卷模板管理', redirect: true},
          children: [
            {
              name: 'test-paper-index',
              path: '',
              component: () => import('@/views/education/examination/test-paper/TestPaper.vue'),
              meta: {title: '试卷模板管理'},
            },
            {
              name: 'paper-form',
              path: 'paper-form',
              component: () => import('@/views/education/examination/test-paper/PaperForm.vue'),
              meta: {title: '新增试卷模板'},
            },
            {
              name: 'paper-detail',
              path: 'paper-detail',
              component: () => import('@/views/education/examination/test-paper/PaperDetail.vue'),
              meta: {title: '试卷详情'},
            },
          ],
        },
        {
          name: 'topic',
          path: 'topic',
          component: () => import('@/views/education/examination/topic/Topic.vue'),
          meta: {title: '题库管理'},
        },
      ],
    },
    {
      name: 'education-train',
      path: 'education-train',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {title: '我的教育培训', redirect: true, icon: 'icon-home'},
      children: [
        {
          name: 'personal-archives',
          path: 'personal-archives',
          component: () => import('@/views/education/personal-archives/PersonalArchives.vue'),
          meta: { title: '个人档案', icon: 'icon-home' }
        },
        {
          name: 'my-train',
          path: 'my-train',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {title: '我的培训', redirect: true},
          children: [
            {
              name: 'my-train-page',
              path: '',
              component: () => import('@/views/education/education-train/my-train/MyTrain.vue'),
              meta: {title: '我的培训列表'},
            },
            {
              name: 'my-train-details',
              path: 'my-train-details',
              component: () => import('@/views/education/education-train/my-train/MyTrainDetail.vue'),
              meta: {title: '我的培训详情'},
            },
            {
              name: 'my-train-study',
              path: 'my-train-study',
              component: () => import('@/views/education/education-train/my-train/MyTrainStudy.vue'),
              meta: {title: '我的培训课件'},
            },
          ],
        },
        {
          name: 'my-exam',
          path: 'my-exam',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {title: '我的考试', redirect: true},
          children: [
            {
              name: 'my-exam-page',
              path: '',
              component: () => import('@/views/education/education-train/my-exam/MyExam.vue'),
              meta: {title: ''},
            },
            {
              name: 'finish-exam',
              path: 'finish-exam',
              component: () => import('@/views/education/education-train/my-exam/FinishExam.vue'),
              meta: {title: ''},
            },
            {
              name: 'answer-question',
              path: 'answer-question',
              component: () => import('@/views/education/education-train/my-exam/AnswerQuestion.vue'),
              meta: {title: '我的考试-答题'},
            },
            {
              name: 'exam-detail-plan',
              path: 'exam-detail-plan',
              component: () => import('@/views/education/education-train/exam-record/ExamDetail.vue'),
              meta: {title: '记录详情'},
            },
          ],
        }
      ],
    },
    {
      name: 'params-set',
      path: 'params-set',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {title: '参数设置', redirect: true, icon: 'icon-home'},
      children: [
        {
          name: 'params-set-page',
          path: 'params-set',
          component: () => import('@/views/education/params-set/ParamsSet.vue'),
          meta: {title: '所属类别设置'},
        },
      ],
    },
  ],
}
